// Gewerk-Landingpages: eine Quelle der Wahrheit für Routen, SEO & Formular-Vorauswahl.
// formService MUSS exakt dem services.js-Titel entsprechen (LeadForm-Dropdown-Vorauswahl).

export const SITE_URL = "https://anfrage.bekajbau.de";

export const serviceLandingData = [
  {
    slug: "trockenbau",
    formService: "Trockenbau",
    metaTitle: "Trockenbau Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Trockenbau vom Fachbetrieb im Raum Hanau & Aschaffenburg: Wände, Decken, Schallschutz, Dachausbau. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/trockenbau",
    h1: "Trockenbau im Raum Hanau & Aschaffenburg",
    heroSubline: "Wände, Decken, Vorsatzschalen und Schallschutz – sauber, termintreu und vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Ob neue Raumaufteilung, abgehängte Decke oder Dachgeschossausbau: BEKAJ BAU setzt Ihr Trockenbau-Projekt präzise und sauber um. Sie erhalten ein kostenloses, unverbindliches Angebot – wir melden uns schnellstmöglich.",
    leistungen: [
      "Trennwände & Vorsatzschalen",
      "Abgehängte Decken",
      "Schall- & Brandschutz",
      "Dachgeschossausbau",
      "Spachtelarbeiten (bis Q4)",
      "Revisionsklappen & Einbauten",
    ],
    vorteile: [
      "Fester Ansprechpartner",
      "Termintreu & saubere Baustelle",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Was kostet Trockenbau pro m²?",
        a: "Das hängt von Aufbau, Dämmung und Untergrund ab. Sie erhalten von uns eine kostenlose, unverbindliche Einschätzung für Ihr konkretes Projekt.",
      },
      {
        q: "Übernehmt ihr auch kleine Trockenbau-Arbeiten?",
        a: "Wir sind auf komplette Projekte spezialisiert – von der einzelnen Trennwand bis zum Dachgeschossausbau. Schildern Sie uns Ihr Vorhaben.",
      },
      {
        q: "In welchem Umkreis arbeitet ihr?",
        a: "Von Großkrotzenburg aus im gesamten Rhein-Main-Gebiet, u. a. Hanau, Aschaffenburg, Frankfurt und Umgebung.",
      },
    ],
  },
  {
    slug: "verputzer",
    formService: "Verputzer / Putzarbeiten",
    metaTitle: "Verputzer in Ihrer Nähe – Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Innen- und Außenputz vom Fachbetrieb im Raum Hanau & Aschaffenburg: Glätt-, Struktur- und Sanierputz. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/verputzer",
    h1: "Verputzer in Ihrer Nähe – Raum Hanau & Aschaffenburg",
    heroSubline: "Innen- und Außenputz, Glättputz, Struktur- und Sanierputz – vom erfahrenen Fachbetrieb aus Großkrotzenburg.",
    intro: "Sie suchen einen zuverlässigen Verputzer in Ihrer Nähe? BEKAJ BAU übernimmt Innen- und Außenputz im Raum Hanau, Aschaffenburg und Umgebung – sauber ausgeführt und termingerecht. Fordern Sie jetzt Ihre kostenlose Einschätzung an.",
    leistungen: [
      "Innenputz & Glättputz",
      "Außen- & Fassadenputz",
      "Sanierputz bei Feuchtigkeit",
      "Struktur- & Dekorputz",
      "Untergrundvorbereitung",
      "Ausbesserungen & Reparaturputz",
    ],
    vorteile: [
      "Fester Ansprechpartner",
      "Saubere Ausführung & Termintreue",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Macht ihr Innen- und Außenputz?",
        a: "Ja – beides, inklusive Glättputz innen sowie Fassaden- und Sanierputz außen.",
      },
      {
        q: "Wir haben feuchte Wände – könnt ihr helfen?",
        a: "Wir setzen Sanierputz-Systeme ein und schauen uns die Ursache vor Ort an. Fordern Sie eine kostenlose Einschätzung an.",
      },
      {
        q: "In welchem Umkreis arbeitet ihr?",
        a: "Von Großkrotzenburg aus im gesamten Rhein-Main-Gebiet, u. a. Hanau, Aschaffenburg, Frankfurt und Umgebung.",
      },
    ],
  },
  {
    slug: "fliesenleger",
    formService: "Fliesenarbeiten",
    metaTitle: "Fliesenleger in Ihrer Nähe – Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Fliesenleger vom Fachbetrieb im Raum Hanau & Aschaffenburg: Bad, Küche, Boden & Großformate. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/fliesenleger",
    h1: "Fliesenleger in Ihrer Nähe – Raum Hanau & Aschaffenburg",
    heroSubline: "Bad, Küche, Wohnräume – präzise Fliesenverlegung vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Vom neuen Badezimmer bis zum großformatigen Wohnzimmerboden: BEKAJ BAU verlegt Fliesen präzise, sauber und mit Blick fürs Detail. Sie erhalten ein kostenloses, unverbindliches Angebot für Ihr Projekt.",
    leistungen: [
      "Fliesenverlegung in Bad & Küche",
      "Bodenfliesen & Großformate",
      "Mosaik- & Naturstein-Verlegung",
      "Abdichtung im Nassbereich",
      "Untergrundvorbereitung & Ausgleich",
      "Silikon- & Fugenarbeiten",
    ],
    vorteile: [
      "Fester Ansprechpartner",
      "Präzise, saubere Verlegung",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Verlegt ihr auch Großformat-Fliesen?",
        a: "Ja, wir verlegen auch Großformate und XXL-Fliesen – inklusive der dafür nötigen Untergrundvorbereitung.",
      },
      {
        q: "Übernehmt ihr die komplette Badsanierung?",
        a: "Ja. In Kombination mit unseren anderen Gewerken setzen wir Ihr Bad komplett um – von der Abdichtung bis zur letzten Fuge.",
      },
      {
        q: "Was kostet das Fliesenlegen pro m²?",
        a: "Der Preis hängt von Format, Untergrund und Verlegemuster ab. Schildern Sie uns Ihr Projekt – die Einschätzung ist kostenlos und unverbindlich.",
      },
    ],
  },
  {
    slug: "sanierung",
    formService: "Renovierung & Sanierung",
    metaTitle: "Sanierung & Renovierung Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Renovierung & Sanierung vom Fachbetrieb im Raum Hanau & Aschaffenburg: Wohnung, Haus, Bad – alles aus einer Hand. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/sanierung",
    h1: "Renovierung & Sanierung im Raum Hanau & Aschaffenburg",
    heroSubline: "Wohnung, Haus oder Bad modernisieren – fachgerecht, koordiniert und aus einer Hand vom Betrieb aus Großkrotzenburg.",
    intro: "Sie möchten Ihre Immobilie renovieren oder sanieren? BEKAJ BAU begleitet Sie von der ersten Einschätzung bis zur Abnahme – mit einem festen Ansprechpartner und sauber koordinierten Gewerken.",
    leistungen: [
      "Wohnungs- & Haussanierung",
      "Badsanierung",
      "Komplettrenovierung einzelner Räume",
      "Boden-, Wand- & Deckenarbeiten",
      "Modernisierung von Bestandsimmobilien",
      "Koordination aller Gewerke",
    ],
    vorteile: [
      "Alles aus einer Hand",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Übernehmt ihr auch komplette Haussanierungen?",
        a: "Ja. Wir sanieren einzelne Räume genauso wie komplette Wohnungen und Häuser – inklusive Koordination aller beteiligten Gewerke.",
      },
      {
        q: "Wie lange dauert eine Sanierung?",
        a: "Das hängt vom Umfang ab. Nach der kostenlosen Einschätzung erhalten Sie von uns einen realistischen Zeitplan für Ihr Projekt.",
      },
      {
        q: "Ist das Angebot kostenlos und unverbindlich?",
        a: "Ja. Sie erhalten nach der Vor-Ort-Einschätzung ein kostenloses, unverbindliches und transparent aufgeschlüsseltes Angebot – Sie entscheiden danach in Ruhe.",
      },
    ],
  },
  {
    slug: "maler",
    formService: "Malerarbeiten",
    metaTitle: "Maler in Ihrer Nähe – Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Malerarbeiten vom Fachbetrieb im Raum Hanau & Aschaffenburg: Innenanstrich, Fassade, Spachtel- & Tapezierarbeiten. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/maler",
    h1: "Maler in Ihrer Nähe – Raum Hanau & Aschaffenburg",
    heroSubline: "Innenanstrich, Fassadenanstrich, Spachtel- und Tapezierarbeiten – sauber und farbtreu vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Frische Farben für Ihre Räume oder ein neuer Anstrich für die Fassade: BEKAJ BAU arbeitet sauber, deckend und termintreu. Fordern Sie jetzt Ihr kostenloses Angebot an – wir melden uns schnellstmöglich.",
    leistungen: [
      "Innenanstrich für Wände & Decken",
      "Fassadenanstrich",
      "Spachtel- & Glättarbeiten",
      "Tapezierarbeiten",
      "Lackierarbeiten an Türen & Zargen",
      "Abkleben, Abdecken & saubere Übergabe",
    ],
    vorteile: [
      "Saubere, deckende Ausführung",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Streicht ihr auch bewohnte Wohnungen?",
        a: "Ja. Wir decken Möbel und Böden sorgfältig ab und hinterlassen die Räume besenrein – auch bei bewohnten Objekten.",
      },
      {
        q: "Macht ihr auch Spachtelarbeiten vor dem Anstrich?",
        a: "Ja, wir bereiten den Untergrund fachgerecht vor – inklusive Spachteln, Schleifen und Grundieren für ein sauberes Endergebnis.",
      },
      {
        q: "Was kosten Malerarbeiten pro m²?",
        a: "Der Preis hängt von Untergrund, Farbaufbau und Umfang ab. Sie erhalten eine kostenlose, unverbindliche Einschätzung für Ihr Projekt.",
      },
    ],
  },
  {
    slug: "bauunternehmen",
    formService: "Komplettlösungen",
    metaTitle: "Bauunternehmen Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Bauunternehmen im Raum Hanau & Aschaffenburg: Innenausbau, Sanierung, Trockenbau, Putz & mehr – alles aus einer Hand. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/bauunternehmen",
    h1: "Ihr Bauunternehmen im Raum Hanau & Aschaffenburg",
    heroSubline: "Innenausbau, Sanierung, Trockenbau, Putz- und Malerarbeiten – alle Gewerke koordiniert aus einer Hand, vom Betrieb aus Großkrotzenburg.",
    intro: "BEKAJ BAU ist Ihr regionales Bauunternehmen für Umbau, Ausbau und Sanierung. Ein fester Ansprechpartner koordiniert alle Gewerke – Sie sparen Zeit, Abstimmungsaufwand und Nerven.",
    leistungen: [
      "Komplettlösungen aus einer Hand",
      "Innenausbau & Umbau",
      "Renovierung & Sanierung",
      "Trockenbau & Putzarbeiten",
      "Fliesen-, Maler- & Bodenarbeiten",
      "Koordination aller Gewerke",
    ],
    vorteile: [
      "Alle Gewerke aus einer Hand",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Welche Leistungen bietet BEKAJ BAU an?",
        a: "Innenausbau, Renovierung & Sanierung, Trockenbau, Putz-, Fliesen-, Maler- und Fassadenarbeiten sowie Bodenbeschichtungen – von der Beratung bis zur Abnahme.",
      },
      {
        q: "Arbeitet ihr mit Subunternehmern?",
        a: "Wir setzen auf ein eingespieltes Team und übernehmen die komplette Koordination. Sie haben immer einen festen Ansprechpartner bei BEKAJ BAU.",
      },
      {
        q: "In welchem Umkreis seid ihr tätig?",
        a: "Von Großkrotzenburg aus im gesamten Rhein-Main-Gebiet, u. a. Hanau, Aschaffenburg, Frankfurt und Umgebung.",
      },
    ],
  },
  {
    slug: "innenausbau",
    formService: "Innenausbau",
    metaTitle: "Innenausbau Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Innenausbau vom Fachbetrieb im Raum Hanau & Aschaffenburg: Raumaufteilung, Decken, Böden, Ausbau. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/innenausbau",
    h1: "Innenausbau im Raum Hanau & Aschaffenburg",
    heroSubline: "Von der neuen Raumaufteilung bis zum fertigen Ausbau – durchdacht geplant und sauber umgesetzt vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Sie möchten Räume neu aufteilen, ausbauen oder modernisieren? BEKAJ BAU übernimmt Ihren Innenausbau von der Planung bis zur Fertigstellung – mit einem festen Ansprechpartner und sauberer Baustelle.",
    leistungen: [
      "Raumaufteilung & Trennwände",
      "Decken- & Wandverkleidungen",
      "Bodenaufbau & Bodenbeläge",
      "Dachgeschoss- & Kellerausbau",
      "Türen & Einbauten",
      "Komplettausbau aus einer Hand",
    ],
    vorteile: [
      "Alles aus einer Hand",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Übernehmt ihr den kompletten Innenausbau?",
        a: "Ja – von der Raumaufteilung über Wände, Decken und Böden bis zur fertigen Übergabe, inklusive Koordination aller Gewerke.",
      },
      {
        q: "Baut ihr auch Dachgeschosse und Keller aus?",
        a: "Ja. Dachgeschoss- und Kellerausbau gehören zu unseren Kernleistungen – inklusive Dämmung, Trockenbau und Oberflächen.",
      },
      {
        q: "Wie läuft die Planung ab?",
        a: "Nach Ihrer Anfrage schauen wir uns das Objekt an, besprechen Ihre Wünsche und erstellen ein transparentes Angebot – kostenlos und unverbindlich.",
      },
    ],
  },
  {
    slug: "fassade",
    formService: "Fassadenarbeiten",
    metaTitle: "Fassadenarbeiten Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Fassadenarbeiten vom Fachbetrieb im Raum Hanau & Aschaffenburg: Fassadenputz, Anstrich, Sanierung & Ausbesserung. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/fassade",
    h1: "Fassadenarbeiten im Raum Hanau & Aschaffenburg",
    heroSubline: "Fassadenputz, Anstrich und Sanierung – für ein gepflegtes und geschütztes Zuhause, vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Eine gepflegte Fassade schützt Ihr Haus und wertet es sichtbar auf. BEKAJ BAU übernimmt Fassadenputz, Anstrich und Ausbesserungen fachgerecht und termintreu – mit kostenloser Einschätzung vorab.",
    leistungen: [
      "Fassadenputz & Oberputz",
      "Fassadenanstrich",
      "Fassadensanierung & Ausbesserung",
      "Riss-Sanierung",
      "Sockelarbeiten",
      "Untergrundvorbereitung & Grundierung",
    ],
    vorteile: [
      "Fachgerechte, wetterfeste Ausführung",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Unsere Fassade hat Risse – was tun?",
        a: "Wir schauen uns die Ursache vor Ort an und sanieren fachgerecht – von der Riss-Verfüllung bis zum neuen Oberputz und Anstrich.",
      },
      {
        q: "Macht ihr Putz und Anstrich in einem?",
        a: "Ja. Sie bekommen Fassadenputz und Anstrich aus einer Hand – sauber aufeinander abgestimmt.",
      },
      {
        q: "Wann ist die beste Jahreszeit für Fassadenarbeiten?",
        a: "In der Regel Frühjahr bis Herbst bei frostfreien Temperaturen. Wir beraten Sie gerne zum passenden Zeitpunkt für Ihr Objekt.",
      },
    ],
  },
  {
    slug: "bodenbeschichtung",
    formService: "Bodenbeschichtungen",
    metaTitle: "Bodenbeschichtung Hanau & Aschaffenburg | BEKAJ BAU",
    metaDescription: "Bodenbeschichtungen vom Fachbetrieb im Raum Hanau & Aschaffenburg: Garage, Keller, Gewerbe – robust & pflegeleicht. Jetzt kostenloses Angebot anfordern.",
    canonicalPath: "/bodenbeschichtung",
    h1: "Bodenbeschichtungen im Raum Hanau & Aschaffenburg",
    heroSubline: "Robuste, pflegeleichte Beschichtungen für Garage, Keller und Gewerbeflächen – vom Fachbetrieb aus Großkrotzenburg.",
    intro: "Ob Garagenboden, Kellerraum oder Gewerbefläche: Eine hochwertige Bodenbeschichtung ist robust, pflegeleicht und langlebig. BEKAJ BAU bereitet den Untergrund fachgerecht vor und beschichtet sauber und gleichmäßig.",
    leistungen: [
      "Garagen-Bodenbeschichtung",
      "Keller- & Hobbyraumböden",
      "Beschichtung von Gewerbeflächen",
      "Untergrundvorbereitung & Schleifen",
      "Grundierung & Versiegelung",
      "Ausbesserung alter Beschichtungen",
    ],
    vorteile: [
      "Robuste, langlebige Systeme",
      "Fester Ansprechpartner",
      "Kostenloses & unverbindliches Angebot",
      "Regionale Fachfirma im Raum Hanau & Aschaffenburg",
    ],
    ablauf: ["Anfrage", "Kostenlose Einschätzung", "Angebot", "Ausführung"],
    faq: [
      {
        q: "Wie lange hält eine Bodenbeschichtung?",
        a: "Bei fachgerechter Untergrundvorbereitung und passendem System viele Jahre – auch bei täglicher Nutzung, z. B. in der Garage.",
      },
      {
        q: "Wie lange kann ich den Boden danach nicht nutzen?",
        a: "Je nach System ist der Boden meist nach 1–3 Tagen wieder begehbar bzw. befahrbar. Den genauen Zeitplan besprechen wir vorab mit Ihnen.",
      },
      {
        q: "Beschichtet ihr auch alte, beschädigte Böden?",
        a: "Ja. Wir schleifen und spachteln den Untergrund fachgerecht, bevor die neue Beschichtung aufgetragen wird.",
      },
    ],
  },
];

// Mapping services.js-value → Landingpage-Route (für interne Verlinkung der Startseiten-Kacheln)
export const serviceValueToRoute = {
  innenausbau: "/innenausbau",
  fassade: "/fassade",
  renovierung: "/sanierung",
  trockenbau: "/trockenbau",
  fliesen: "/fliesenleger",
  boden: "/bodenbeschichtung",
  malerarbeiten: "/maler",
  komplett: "/bauunternehmen",
  verputzer: "/verputzer",
};

export const getServiceLandingBySlug = (slug) =>
  serviceLandingData.find((s) => s.slug === slug) || null;
